import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import RouteList from '../components/routes/RouteList';
import { useAuth } from '../hooks/useAuth';

const RoutesPage: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const { query } = useParams<{ query?: string }>();
  console.log('RoutesPage query param:', query);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Routes</h1>
            <p className="mt-2 text-gray-600">
              Discover and manage transportation routes in your area.
            </p>
          </div>

          {/* Create Route Button */}
          {isAuthenticated && user?.roles?.some(role => role.name === 'driver') && (
            <Link
              to="/routes/create"
              className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Plus className="h-4 w-4" />
              <span>Create Route</span>
            </Link>
          )}
        </div>

        {/* Route List */}
        <RouteList query={query} />
      </div>
    </div>
  );
};

export default RoutesPage;
